
import * as types from "./mutation_types"


export const open = ({ commit },data) => {
    commit(types.SET_SHOW_MESSAGE)
    commit(types.SET_CURRENT_ITEM,data)
}
export const closeModal = ({ commit }) => {
    commit(types.SET_HIDE_MESSAGE)
    commit(types.SET_CURRENT_ITEM,null)
}
export const isLoading = ({ commit }) => {
    commit(types.SET_SHOW_LOADING)
}





export const resetData = ({ commit }) => {
    commit(types.RESET)
}



